export enum AuthServiceErrors {
  CHANGE_PASSWORD = "CHANGE_PASSWORD",
  TOO_MANY_ATTEMPTS = "TOO_MANY_ATTEMPTS",
  USER_NOT_MIGRATED_TO_COGNITO = "USER_NOT_MIGRATED_TO_COGNITO",
  BLOCKED_USER = "BLOCKED_USER"
}

export class AuthServiceError extends Error {
  code: AuthServiceErrors;

  constructor(code: AuthServiceErrors, message?: string) {
    super(message || code);
    this.name = "AuthServiceError";
    this.code = code;
  }
}